// import { ViewChild, 
//          Component,
//          NgZone     } from '@angular/core';
import { Component } from '@angular/core';
@Component({
  selector: 'dst-app',
  template: `
    <div class="view-main" [style.height]="'100%'">
      <router-outlet></router-outlet>  
    </div>`,
  styles: [`
  :host { 
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  `],
})
export class AppComponent { }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/app-component.ts